// extracted by mini-css-extract-plugin
export default {"root":"Qs00WfIT3u","line":"CHZAfrWZZl","text":"nmCge7EUI0","icon":"rp_1SyPDR1"};